import DateShareBody from './DateShareBody';

const View = (props) => <DateShareBody {...props} />;

export default View;
